const datoraErrorKeys = { empty: 'discountErrorEmpty', double: 'discountErrorDouble', failed: 'discountErrorFailed', invalid: 'discountErrorInvalid' };

const truncate = (str, len = 10) => str.length > len ? str.substring(0, len) + '...' : str;

// Shopify-kompatible Preisformatierung
function shopifyFormatCurrency(cents, formatString) {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return '0';
    const numString = (number / 100.0).toFixed(precision);
    const parts = numString.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  return formatString.replace(placeholderRegex, (match, placeholder) => {
    switch (placeholder) {
      case 'amount':
        return formatWithDelimiters(cents, 2);
      case 'amount_no_decimals':
        return formatWithDelimiters(cents, 0);
      case 'amount_with_comma_separator':
        return formatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return formatWithDelimiters(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return formatWithDelimiters(cents, 2, "'", '.');
      case 'amount_no_decimals_with_space_separator':
        return formatWithDelimiters(cents, 0, ' ');
      case 'amount_with_space_separator':
        return formatWithDelimiters(cents, 2, ' ', ',');
      case 'amount_with_period_and_space_separator':
        return formatWithDelimiters(cents, 2, ' ', '.');
      default:
        return match;
    }
  });
}

const formatPrice = function(cents) {
  return shopifyFormatCurrency(cents, window.themeVariables.settings.moneyFormat);
}

function wrapFromPrice(formattedPrice, div) {
  if (div && div.dataset.datoraPriceVaries === 'true' && window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.fromPriceHtml) {
    return window.themeVariables.strings.fromPriceHtml.replace('_PRICE_', formattedPrice);
  }
  return formattedPrice;
}

// Hilfsfunktionen für Preisanzeige (EUR mit transcy-money span vs. andere Währungen mit Textknoten)
function setPriceText(container, price) {
  const visuallyHidden = container.querySelector('.visually-hidden');

  // Alles nach dem visually-hidden span entfernen
  while (visuallyHidden && visuallyHidden.nextSibling) {
    visuallyHidden.nextSibling.remove();
  }

  // Neuen Preis einfügen (kann HTML enthalten bei EUR/Transcy)
  if (visuallyHidden) {
    visuallyHidden.insertAdjacentHTML('afterend', price);
  } else {
    container.innerHTML = price;
  }
}

const applyDatoraDiscount = async function() {
  const datoraInput = document.querySelector('input[name="datora-discount"][form="datora-form"]') ||
                     document.querySelector('input[name="datora-discount"]');
  if(!datoraInput) return;
  const discountCode = datoraInput.value.trim();
  if(discountCode.length < 1){
    errorDatoraDiscount('show', 'empty');
    return;
  }
  const datoraContainer = datoraInput.closest('.datora-discount-field-container');
  errorDatoraDiscount('hide');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const cleanInput = discountCode.trim().toUpperCase();
  const getCurrentDiscountCode = await co2.getDiscountCode();
  if(getCurrentDiscountCode && getCurrentDiscountCode.trim().toUpperCase() === cleanInput){
    if(datoraContainer) datoraContainer.classList.remove('loading');
    errorDatoraDiscount('show', 'double', discountCode);
    return;
  }

  const resultChangeDiscountCode = await co2.setDiscountCode(discountCode);
  if(resultChangeDiscountCode){
    refreshCartAndPrices();
    if (typeof restoreDiscountState === 'function') restoreDiscountState();
  } else {
    errorDatoraDiscount('show', 'failed', discountCode);
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
};

const removeDatoraDiscount = async function() {
  errorDatoraDiscount('hide');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const resultRemoveDiscountCode = await co2.removeDiscountCode();
  if(resultRemoveDiscountCode){
    refreshCartAndPrices();
    document.querySelectorAll('.discounted[data-datora-price]').forEach(div => {
      resetProductGridDiscount(div);
    });
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
}

function setDatoraClasses(parentElem, fakeComparePrice) {
  const compare = parentElem.querySelector('.price-list .price--compare');
  if (compare && typeof setPriceText === 'function') {
    compare.classList.remove('hidden');
    setPriceText(compare, fakeComparePrice);
  }
}

function errorDatoraDiscount(type = 'show', reason = 'invalid', code = '') {
  const cartDrawer = document.querySelector('cart-drawer');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  const errorDiv = datoraContainer ? datoraContainer.querySelector('.datora-discount-error') : null;
  if(type == "show"){
    let errorAlert = window.themeVariables?.strings?.[datoraErrorKeys[reason]] ?? false;
    if(!errorAlert) return;
    const cleanCode = code.trim().toUpperCase();
    errorAlert = errorAlert.replace("[[CODE]]",truncate(cleanCode,10));
    if(datoraContainer) datoraContainer.classList.add('error');
    if(errorDiv) errorDiv.style.display = 'block';
    if(reason == "empty"){
      if(datoraContainer) datoraContainer.querySelector('.datora-input input').focus();
    }else if(reason == "double" || reason == "invalid" || reason == "failed"){
      if(datoraContainer){
        const input = datoraContainer.querySelector('.datora-input input');
        const isActive = datoraContainer.getAttribute('data-discount-state') === 'active';
        if(isActive){
          if(typeof restoreDiscountState === 'function') restoreDiscountState();
        }else{
          input.value = '';
          input.classList.remove('is-filled');
        }
      }
    }
    if(datoraContainer) datoraContainer.querySelector('.datora-discount-error span').innerHTML = errorAlert;
  }else{
    if(cartDrawer) cartDrawer.classList.remove('error');
    if(datoraContainer) datoraContainer.classList.remove('error');
    if(errorDiv) errorDiv.style.display = '';
  }
}


function resetProductGridDiscount(div){
  div.classList.remove('discounted');
  div.classList.remove('price--datora-loading');
  const oldPrice = div.dataset.datoraPrice;
  const oldCompare = div.dataset.datoraCompare;
  const oldCompareCheck = (oldCompare && oldCompare != "") ? parseInt(oldCompare) : 0;
  if(oldCompareCheck == 0){
    const compare = div.querySelector('.price--compare');
    if (compare) compare.classList.add('hidden');
  }
  const basePriceFormatted = wrapFromPrice(formatPrice(oldPrice), div);
  const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
  if (priceContainer && typeof setPriceText === 'function') {
    setPriceText(priceContainer, basePriceFormatted);
  }
  const datoraInfo = div.querySelector('[data-datora]');
  if (datoraInfo) datoraInfo.textContent = '';
  const badge = div.querySelector('.datora.discount-badge');
  if (badge) badge.setAttribute('hidden', true);
}

async function updateProductGridDiscounts(scope) {
  scope = scope || document;

  const discountCode = await co2.getDiscountCode();
  if (!discountCode) {
    scope.querySelectorAll('[data-datora-product-id]').forEach(function (el) {
      el.classList.remove('price--datora-loading');
      resetProductGridDiscount(el);
    });
    return;
  }

  for (const div of scope.querySelectorAll('[data-datora-product-id]')) {
    const vid = div.dataset.datoraVariantId;
    const pid = div.dataset.datoraProductId;
    const tags = div.dataset.datoraTags;
    const price = div.dataset.datoraPrice;
    const onSale = div.dataset.datoraSalePrice === 'true';

    if (!(vid && pid && price)) {
      div.classList.remove('price--datora-loading');
      continue;
    }

    try {
      const data = await co2.itemDiscountFull(Number(pid), Number(vid), tags ? tags.split(',') : [], Number(price), 1, false, onSale);
      div.classList.remove('price--datora-loading');

      if (!data) {
        resetProductGridDiscount(div);
        continue;
      }

      let validDisc = false;
      let newPrice, badgeText;

      /* DATORACODE - Compact-Flag: Badge ohne Rabattcode wenn data-datora-compact="true" */
      const compact = div.dataset.datoraCompact === 'true';

      if (data.calc === "perc" && data.discPerc > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        badgeText = compact
          ? `<b>-${data.discPerc}%</b>`
          : `<b>-${data.discPerc}%</b> (${discountCode.toUpperCase()})`;
      } else if (data.calc === "amt" && data.discAmt > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        const discountValue = price - data.discPrice;
        badgeText = compact
          ? `-${formatPrice(discountValue)}`
          : `-${formatPrice(discountValue)} | ${discountCode.toUpperCase()}`;
      }

      if (validDisc) {
        div.classList.add('discounted');
        const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
        if (priceContainer && typeof setPriceText === 'function') {
          setPriceText(priceContainer, wrapFromPrice(newPrice, div));
        }
        const originalPriceAsComparePrice = formatPrice(price);
        setDatoraClasses(div, originalPriceAsComparePrice);
        const datoraBadge = div.querySelector('[data-datora]');
        if (datoraBadge) datoraBadge.innerHTML = badgeText;
        const badge = div.querySelector('.datora.discount-badge');
        if (badge) badge.removeAttribute('hidden');
      } else {
        resetProductGridDiscount(div);
      }
    } catch (error) {
      console.error('[datora] discount error:', error);
      div.classList.remove('price--datora-loading');
      resetProductGridDiscount(div);
    }
  }
}

// ---------------------------------------------------------------------------
// Dawn theme integration
// ---------------------------------------------------------------------------

// DATORACODE - Expose for use in shop-the-look-slider.js
window.datoraUpdatePrices = updateProductGridDiscounts;

// Cart refresh via Dawn pub/sub (global.js bridge dispatches cart.update for co2)
function refreshCartAndPrices() {
  fetch(window.Shopify?.routes?.root + 'cart.js', { cache: 'reload' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'datora', cartData: cart });
    })
    .catch(function (e) {
      console.error('[datora] cart refresh error:', e);
    });
}

// Dawn pub/sub event subscriptions

subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
  window.dispatchEvent(new CustomEvent('cart.update', { detail: { cart: event.cartData } }));
  if (typeof restoreDiscountState === 'function') restoreDiscountState();
});

subscribe(PUB_SUB_EVENTS.variantChange, function () {
  if (typeof co2 === 'undefined') return;
  requestAnimationFrame(function () {
    updateProductGridDiscounts();
  });
});

window.addEventListener('co2.cart.initialized', function() {
  updateProductGridDiscounts();
  restoreDiscountState();
});

let autoDiscountChecked = false;
window.addEventListener('co2.cart.initialized', async function() {
  if (autoDiscountChecked) return;
  autoDiscountChecked = true;
  const settings = window.themeVariables?.settings;
  if (!settings?.autoDiscountEnabled || !settings?.autoDiscountCode) return;
  if (typeof co2 === 'undefined') return;
  const currentCode = await co2.getDiscountCode();
  if (currentCode) return;
  const success = await co2.setDiscountCode(settings.autoDiscountCode);
  if (success) {
    refreshCartAndPrices();
  }
});

window.datoraUpdatePrices = updateProductGridDiscounts;
